import {useCallback, useState} from "react";
import {useLongPress} from "use-long-press";
import {IconButton, IconButtonProps} from "@mui/joy";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowsSpin} from "@fortawesome/pro-regular-svg-icons";
import {useBomb} from "../bomb/bomb.tsx";
import {useRefreshSet} from "../util/tqrefresh.tsx";
import {triggerFullReset} from "../reset.tsx";

export function RefreshButton(props: IconButtonProps) {
    const bomb = useBomb();
    const [isRefreshing, setIsRefreshing]
        = useState<boolean>(false);
    const refreshSet = useRefreshSet();
    const doTotalRefresh = useCallback(() => {
        setIsRefreshing(true);
        setTimeout(() => {
            triggerFullReset();
            setIsRefreshing(false);
        }, 0);
    }, []);
    const doRefresh = useCallback(() => {
        setIsRefreshing(true);
        refreshSet.invalidate().then(() => {
            setIsRefreshing(false);
        }).catch(bomb);
    }, [bomb, refreshSet]);
    const bindLongPress = useLongPress(() => {
        doTotalRefresh()
    })();

    return <IconButton {...props} onClick={doRefresh} {...bindLongPress}>
        <FontAwesomeIcon icon={faArrowsSpin} size="2x"
                         spin={isRefreshing}/>
    </IconButton>;
}